import { Grid2 as Grid, Skeleton, Card } from '@mui/material';

const DetailsSummarySkeleton = () => (
  <div className="w-full flex flex-col space-y-0">
    <div className="flex gap-y-2 gap-x-3 justify-between items-center pb-4">
      <Skeleton variant="text" width="30%" height={60} className="bg-neutral-main/20" />
      <Skeleton variant="text" width="10%" height={30} className="bg-neutral-main/20" />
    </div>
    <Grid container className="w-full" spacing={{ xs: 1, md: 2 }}>
      <Grid size={{ xs: 12, md: 8 }} spacing={{ xs: 1, md: 2 }}>
        <Card
          className="bg-neutral-main/10 rounded-2xl h-[270px] lg:h-[450px] mb-2 md:mb-4"
          sx={{ boxShadow: 'none' }}
        />
        <Grid container className="w-full" spacing={{ xs: 1, md: 2 }}>
          <Grid size={{ xs: 12, md: 3 }}>
            <Card className="bg-neutral-main/10 rounded-2xl p-6 h-32" sx={{ boxShadow: 'none' }} />
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <Card className="bg-neutral-main/10 rounded-2xl p-6 h-32" sx={{ boxShadow: 'none' }} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Card className="bg-neutral-main/10 rounded-2xl p-6 h-32" sx={{ boxShadow: 'none' }} />
          </Grid>
        </Grid>
      </Grid>
      <Grid size={{ xs: 12, md: 4 }} display={'flex'} flexDirection={'column'} rowGap={2}>
        <Card className="bg-neutral-main/10 rounded-2xl p-6 md:h-full" sx={{ boxShadow: 'none' }}>
          <Skeleton variant="text" className="w-full" />
          <Skeleton variant="text" className="w-full" />
          <Skeleton variant="text" className="w-full" />
          <Skeleton variant="text" className="w-full" />
          <Skeleton variant="text" className="w-1/2" />
        </Card>
      </Grid>
    </Grid>
  </div>
);

export default DetailsSummarySkeleton;
